import React from 'react';
import { useApp } from '../context/AppContext';

function Terms() {
  const { t } = useApp();

  return (
    <div className="min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold title-gradient mb-8">
          {t('terms.title')}
        </h1>
        
        <div className="glass-effect rounded-lg p-8 space-y-6 text-text-light dark:text-text-dark">
          {/* Informações da Empresa */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.company.title')}
            </h2>
            <div className="space-y-2">
              <p><strong>{t('terms.company.name')}:</strong> Thiago Henrique Silva Alves</p>
              <p><strong>{t('terms.company.cnpj')}:</strong> 61.458.294/0001-94</p>
              <p><strong>{t('terms.company.address')}:</strong> Rua Fernão Dias, 3804 - Belo Horizonte, MG - CEP 30285-160 - Brasil</p>
              <p><strong>{t('terms.company.email')}:</strong> thiago@thz.dev.br</p>
            </div>
          </section>

          {/* Aceitação dos Termos */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.acceptance.title')}
            </h2>
            <p>{t('terms.acceptance.description')}</p>
          </section>

          {/* Uso do Site */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.usage.title')}
            </h2>
            <p className="mb-4">{t('terms.usage.description')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('terms.usage.items.0')}</li>
              <li>{t('terms.usage.items.1')}</li>
              <li>{t('terms.usage.items.2')}</li>
              <li>{t('terms.usage.items.3')}</li>
            </ul>
          </section>

          {/* Propriedade Intelectual */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.intellectual.title')}
            </h2>
            <p>{t('terms.intellectual.description')}</p>
          </section>

          {/* Serviços Oferecidos */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.services.title')}
            </h2>
            <p className="mb-4">{t('terms.services.description')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('terms.services.items.0')}</li>
              <li>{t('terms.services.items.1')}</li>
              <li>{t('terms.services.items.2')}</li>
              <li>{t('terms.services.items.3')}</li>
            </ul>
          </section>

          {/* Limitação de Responsabilidade */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.liability.title')}
            </h2>
            <p>{t('terms.liability.description')}</p>
          </section>

          {/* Links Externos */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.links.title')}
            </h2>
            <p>{t('terms.links.description')}</p>
          </section>

          {/* Modificações */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.modifications.title')}
            </h2>
            <p>{t('terms.modifications.description')}</p>
          </section>

          {/* Lei Aplicável */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.law.title')}
            </h2>
            <p>{t('terms.law.description')}</p>
          </section>

          {/* Contato */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('terms.contact.title')}
            </h2>
            <p>{t('terms.contact.description')}</p>
          </section>

          <div className="pt-6 border-t border-gray-300 dark:border-gray-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t('terms.lastUpdate')}: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
